import { Box, BoxProps, Flex, Text, TextProps } from '@chakra-ui/react'
import { useTranslation } from 'next-i18next/pages'
import Link from 'next/link'
import { useEnvironment } from '@/hooks/useEnvironment'
import { Image } from '@/components/HOC/Image'
import LogoIcon from '@/public/assets/brand/logo-36x36.png'

export const Logo = ({ textStyles, logoStyles }: { textStyles?: TextProps; logoStyles?: BoxProps }) => {
  const { t } = useTranslation()
  const { isProduction } = useEnvironment()

  return (
    <Link href={'/'}>
      <Flex
        cursor={'pointer'}
        alignItems={'center'}
        justifyContent={{ sm: 'center', lg: 'start' }}
        gap={{ base: 1.5, lg: 2 }}
        h={'full'}
      >
        <Box w={8} {...logoStyles}>
          <Image src={LogoIcon} alt="" />
        </Box>
        <Box fontSize={'24px'} {...textStyles}>
          <Text lineHeight={'0.9'} fontFamily={'mono'} fontWeight={600} pos={'relative'}>
            {t('common.ninja-blaze')}
          </Text>
          {!isProduction && (
            <Text
              mt={{ base: 0, lg: 1 }}
              fontSize={'10px'}
              fontWeight={{ base: 700, lg: 600 }}
              fontFamily={'mono'}
              lineHeight={'12px'}
              color={'ninja.300'}
              h={{ base: '11px', lg: 'auto' }}
              bgBlendMode={'overlay'}
              bg={`linear-gradient(291.97deg, #8E83FB 31.11%, #5D52EE 97.01%), rgba(255, 255, 255, 0.2)`}
              backgroundClip={'text'}
              __css={{
                '-webkit-text-fill-color': 'transparent',
              }}
            >
              {t('common.testnet')}
            </Text>
          )}
        </Box>
      </Flex>
    </Link>
  )
}
